import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Box, Typography, IconButton, Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import CallIcon from "@mui/icons-material/Call";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import { connect } from "react-redux";
import * as actions from "../../store/actions/actionIndex";
import { decryptPhoneNumber } from "../../helpers/utility";

function ChatModal(props) {
  console.log(props.chatData)
 const transcriptArray =
    props.chatData && props.chatData.length > 0
      ? props.chatData[0].transcript
      : [];
const conversation = transcriptArray.flatMap((msg) => {
  if (msg.type === "overlap") {
    return msg.text.split("|").map((part) => {
      part = part.trim();
      const sender = part.startsWith("Agent:") ? "agent" : "customer";
      const text = part.replace(/^Agent:|^Customer:/, "").trim();
      return { sender, text };
    });
  }

  const sender = msg.text.startsWith("Agent:") ? "agent" : "customer";
  const text = msg.text.replace(/^Agent:|^Customer:/, "").trim();
  return { sender, text };
});
  return (
      <Dialog
      open={props.isOpen}
      PaperProps={{
        sx: {
          width: "500px",
          p: 0,
          background: "#f9f9f9",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          flexDirection: "column",
          borderBottom: "1px solid #ddd",
          padding: "16px",
          gap: "4px",
          marginBottom: "20px"
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <QuestionAnswerIcon sx={{ color: "#1976d2" }} />
            <Typography variant="h6" fontWeight="bold">
              Call Transcript - {decryptPhoneNumber(props.chatData[0].id)}
            </Typography>
          </Box>
          <IconButton onClick={props.onClose} sx={{ color: "grey.500", p: 0 }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

     <DialogContent
  sx={{
    padding: "16px",
    background: "#f9f9f9",
    maxHeight: "400px",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: conversation.length === 0 ? "center" : "flex-start",
  }}
>
  {conversation.length === 0 ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
        marginTop: 4,
        minHeight: "200px"
      }}
    >
      {/* <img
        src="https://placehold.co/600x400/000000/FFFFFF.png?text=No+Chat+Data+Available" // replace with your placeholder image path
        alt="No chat"
        style={{ width: 120, height: 120, opacity: 0.5 }}
      /> */}
      <Typography sx={{ color: "#888", fontSize: "1rem", textAlign: "center" }}>
        No chat data available
      </Typography>
    </Box>
  ) : (
    conversation.map((line, index) => {
      const isAgent = line.sender === "agent";
      const isCustomer = line.sender === "customer";

      return (
        <Box
          key={index}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: isAgent
              ? "flex-start"
              : isCustomer
              ? "flex-end"
              : "center",
            gap: "12px",
            marginBottom: "12px",
            position: "relative",
          }}
        >
          {/* Agent Icon */}
          {isAgent && (
            <Box
              sx={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                backgroundColor: "#e0f0ff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PersonIcon sx={{ color: "#1976d2", fontSize: 18 }} />
            </Box>
          )}

          {/* Chat Bubble */}
          <Box
            sx={{
              maxWidth: "70%",
              padding: "12px",
              borderRadius: "16px",
              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
              backgroundColor: isAgent ? "#e6f0ff" : isCustomer ? "#e6ffe6" : "#f0f0f0",
              border: isAgent
                ? "1px solid #bbd4ff"
                : isCustomer
                ? "1px solid #b4ffb4"
                : "1px solid #ccc",
              display: "flex",
              flexDirection: "column",
              position: "relative",
            }}
          >
            {/* Badge and timestamp */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "6px",
              }}
            >
              <Box
                sx={{
                  padding: "2px 8px",
                  borderRadius: "12px",
                  fontSize: "0.75rem",
                  fontWeight: "bold",
                  backgroundColor: isAgent ? "#1976d2" : isCustomer ? "#4caf50" : "#ccc",
                  color: "#fff",
                }}
              >
                {isAgent ? "Agent" : isCustomer ? "Customer" : "System"}
              </Box>
            </Box>

            <Typography sx={{ fontSize: "0.875rem", lineHeight: 1.5 }}>
              {line.text}
            </Typography>
          </Box>

          {/* Customer Icon */}
          {isCustomer && (
            <Box
              sx={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                backgroundColor: "#e0ffe0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CallIcon sx={{ color: "#4caf50", fontSize: 18 }} />
            </Box>
          )}
        </Box>
      );
    })
  )}
</DialogContent>

    </Dialog>

  );
}


const mapStateToProps = (state) => {
  return {
    campConf: state.agentConfig.campConf,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAgentDial: (agentId, phone, leadId, redial, callerId, phoneType) =>
      dispatch(
        actions.agentDial(agentId, phone, leadId, redial, callerId, phoneType)
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatModal);
